import { render, staticRenderFns } from "./ReminderContactDetailModel.vue?vue&type=template&id=bf3d7700&"
import script from "./ReminderContactDetailModel.vue?vue&type=script&lang=js&"
export * from "./ReminderContactDetailModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports